import {
  IMessage,
  INotificationBellProps,
  INotificationCenterProps,
  IStoreQuery,
  useFetchNotifications
} from "@novu/notification-center";
import {
  Dispatch,
  FC,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import Footer from "./footer";
import EmptyState from "./empty";
import Header from "./header";
import dayjs from "dayjs";
import { NotifyError } from "./notification";
// import NotifyItem from "./Layout";
import SmallAppLoader from "../../atoms/app-loader/smallAppLoader";
import NotifyItem from "./Layout";
import { checkExpiry } from "./utility";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useGetUnseenCountQuery } from "./slice/notificationSlice";

export interface IMessagePayload {
  username: string;
  title: null;
  count: null;
  enrollmentStatus: null;
  headers: Headers;
  primaryUrl?: string;
  secondaryUrl?: string;
  isBackendUrl: boolean;
  requestType: string;
  body?: unknown;
  redirectUrl?: string;
}

export interface Headers {
  x_muse_uuid: string;
  x_muse_org: string;
}

interface CustomNotificationCenterProps
  extends Partial<INotificationCenterProps> {
  bellICon?: FC<INotificationBellProps>;
  notifyErrors?: string;
  setNotifyErrors: Dispatch<SetStateAction<Partial<NotifyError>[] | []>>;
  expirationLimit: {
    value: number;
    unit: dayjs.UnitType;
  };
}

const CustomNotificationCenter: FC<CustomNotificationCenterProps> = (props) => {
  const user = useSelector((state: RootState) => state.UserInfoSlice);
  const { data: unreadCount, refetch: refetchCount } = useGetUnseenCountQuery({
    subscriberId: user.profile.subscriberIdNovu
  });
  const [feedMap, setFeedMap] = useState<{
    name: string | undefined;
    feedIdentifier: string | undefined;
  }>({
    name: undefined,
    feedIdentifier: undefined
  });

  const containerRef = useRef<HTMLDivElement | null>(null);

  const [_, setCurrentPage] = useState<number>(0);

  const [query, setQuery] = useState<IStoreQuery>({
    limit: 5,
    feedIdentifier: feedMap.feedIdentifier
  });

  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);

  useEffect(() => {
    setQuery((prev) => ({
      ...prev,
      feedIdentifier: feedMap.feedIdentifier
    }));
  }, [feedMap.feedIdentifier]);

  const {
    refetch: refetchNotification,
    data,
    isError,
    isFetching,
    isLoading,
    isFetchingNextPage
  } = useFetchNotifications(
    { query },
    {
      refetchOnMount: true,
      networkMode: "always"
    }
  );

  console.log(data);

  if (isError) {
    // props.setNotifyErrors((oldErrors) => {
    //   if(oldErrors?.length > 0) {
    //     return [
    //       ...oldErrors,
    //       {
    //         label: "Failed",
    //         severity: "error",
    //         messageList: ["Error while fetching notifications"] as unknown as [],
    //       },
    //     ];
    //   } else {
    //     return [{
    //       label: "Failed",
    //       severity: "error",
    //       messageList: ["Error while fetching notifications"] as unknown as [],
    //     }]
    //   }
    // });
  }

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setIsFirstTimeLoad(true);
    refetchNotification();
  }, [query]);

  return (
    <div className=" bg-bkg rounded-3xl shadow-lg ring-1 ring-gray-900/5">
      <Header
        query={query}
        setQuery={setQuery}
        messageIds={data?.pages.flatMap((page) =>
          page.data.map((msg) => msg._id)
        )}
        setNotifyErrors={props.setNotifyErrors}
        setFeedMap={setFeedMap}
        refetchCount={refetchCount}
        refetchNotification={refetchNotification}
      />
      <div
        className="w-full flex flex-col gap-2 h-[500px] overflow-y-auto px-4 py-2"
        ref={containerRef}
        id="messageContainer"
      >
        {(isFetching || isLoading) && isFirstTimeLoad && !isFetchingNextPage ? (
          <div className=" h-[500px] flex justify-center items-center">
            <SmallAppLoader
              widthClassName="w-6"
              heightClassName="h-6"
              loadingText="Loading..."
            />
          </div>
        ) : data?.pages[0].totalCount === 0 ? (
          <EmptyState />
        ) : (
          <>
            {data?.pages.flatMap((page) =>
              page.data.slice(0, 5).map((message) => {
                // return filterMessage(query, message) &&
                if (isFirstTimeLoad) {
                  setIsFirstTimeLoad(false);
                }
                // TODO redundant condition
                return (
                  <NotifyItem
                    message={message}
                    key={message._id}
                    setNotifyErrors={props.setNotifyErrors}
                    refetchCount={refetchCount}
                    isLastNotification={
                      data?.pages[0]?.data[data?.pages[0]?.data?.length - 1]
                        ._id === message._id
                    }
                  />
                );
              })
            )}
            {isFetchingNextPage && (
              <div className="text-xs">
                <div className="flex flex-col items-center">
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      className={`${"w-6 aspect-square"} inline mr-2 text-gray-200  animate-spin dark:text-gray-600 dark:text-gray-400 fill-green-500`}
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p className="mt-2 text-sm">Loading...</p>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default CustomNotificationCenter;
